<template>
    <div>
        <table-filter v-model="filter" :columns="columns"/>
        <div class="row justify-between">
            <div></div>
            <q-table-columns
                color="secondary"
                class="q-mr-sm"
                style="width: 100px;"
                v-model="visibleColumns"
                :columns="columns"
            />
        </div>
        <h-table
            :data='data'
            row-key="label"
            :columns='columns'
            :visible-columns="visibleColumns"
            :filter="filter"
            :pagination.sync="serverPagination"
            :rows-per-page-options="perPageOptions"
            :loading="loading"
            ref="table"
            @request="fetch"
        >
        </h-table>
    </div>
</template>

<script>
import HTable from '@/HTable'
import HTh from '@/HTh'
import TableFilter from '@/TableFilter'

import tableHelpers from 'components/HTable/helpers'
import api from 'mixins/api'
import makeCorrectAmount from 'mixins/makeCorrectAmount'

import {
    date,
    QBtn,
    QField,
    QIcon,
    QInput,
    QModal,
    QPopover,
    QSelect,
    QTable,
    QTableColumns,
    QTd,
    QTh,
    QTooltip,
    QTr,
} from 'quasar'

export default {
    name: 'ProjectTransactionsList',

    components: {
        HTable,
        HTh,
        QField,
        QInput,
        QSelect,
        QBtn,
        QIcon,
        QTable,
        QTableColumns,
        QTr,
        QTh,
        QTd,
        QPopover,
        QModal,
        QTooltip,
        TableFilter,
    },

    mixins: [
        tableHelpers,
        api,
        makeCorrectAmount,
    ],

    data () {
        return {
            columns: [
                {
                    label: 'ID',
                    field: 'id',
                    name: 'id',
                    sortable: true,
                    filter: '',
                    type: 'text',
                    align: 'left',
                },
                {
                    label: 'Дата создания',
                    field: 'created_at',
                    name: 'created_at',
                    sortable: true,
                    filter: '',
                    align: 'left',
                    format: value => date.formatDate(value, 'DD.MM.YYYY HH:mm:ss'),
                },
                {
                    label: 'Номер счёта',
                    field: 'bill',
                    name: 'bill_number',
                    sortable: true,
                    filter: '',
                    type: 'text',
                    align: 'left',
                    format: bill => {
                        return bill ? bill.number : ''
                    },
                },
                {
                    label: 'Сумма',
                    field: 'amount',
                    name: 'amount',
                    sortable: true,
                    type: 'number',
                    filter: '',
                    align: 'left',
                    format: val => {
                        val = val / 100

                        return this.resolveAmount(val)
                    },
                },
                {
                    label: 'Баланс',
                    field: 'balance_state',
                    name: 'balance_state',
                    sortable: true,
                    type: 'number',
                    filter: '',
                    align: 'left',
                    format: val => {
                        val = val / 100

                        return this.resolveAmount(val)
                    },
                },
                {
                    label: 'Тип действий',
                    field: 'balance',
                    name: 'type',
                    sortable: true,
                    type: 'text',
                    align: 'left',
                    format: balance => {
                        return balance ? balance.type : ''
                    },
                },
                {
                    label: 'Способ оплаты',
                    field: 'payment_method_type',
                    name: 'payment_type',
                    sortable: true,
                    type: 'text',
                    align: 'left',
                },
                {
                    label: 'Комментарий',
                    field: 'balance',
                    name: 'reason',
                    sortable: true,
                    type: 'text',
                    align: 'left',
                    format: balance => {
                        return balance
                            ? balance.auto_adjustments
                                ? balance.auto_adjustments.reason
                                : balance.manual_adjustments
                                    ? balance.manual_adjustments.reason
                                    : balance.paid_bill
                                        ? balance.paid_bill.reason
                                        : balance.refund
                                            ? balance.refund.reason
                                            : balance.bonus
                                                ? balance.bonus.reason
                                                : ''
                            : ''
                    },
                },
                {
                    label: 'Менеджер',
                    field: 'user',
                    name: 'manager_email',
                    sortable: true,
                    filter: '',
                    type: 'text',
                    align: 'left',
                    format: user => {
                        return user.email
                    },
                },
            ],
            data: [],

            loading: false,

            perPageOptions: [10, 20, 40, 60],

            visibleColumns: this.getVisibleColumns() || [
                'id',
                'bill_number',
                'amount',
                'balance_state',
                'manager',
                'created_at',
            ],

            filterCols: {},
        }
    },

    mounted () {
        this.fetch({
            pagination: this.serverPagination,
            filter: this.filter,
        })
    },

    methods: {
        fetchTransactions () {
            this.fetch({
                pagination: this.serverPagination,
                filter: this.filter,
            })
        },

        fetch ({ pagination, filter }) {
            this.loading = true
            this.query = this.getQuery(pagination, filter)
            this.api.get(`projects/${this.$route.params.id}/transactions${this.query}`).then((response) => {
                if (this.verifyResponse(response)) {
                    this.updatePagination(pagination, response.data.total)
                    this.updateData(response.data.transactions)
                }
                this.loading = false
            }).catch(error => {
                console.error(error)
                this.loading = false
            })
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectTransactions/ProjectTransactionsList.vue